import flatten from "lodash/flatten";
import { all, put, takeEvery } from "redux-saga/effects";

import {
  BillingDocumentAction,
  BillingRunAction,
  LedgerEntryAction,
} from "actions";

import { LedgerAccountAction } from "actions/ledgerAccounts";

import {
  BILLING_DOCUMENT,
  BILLING_RUN,
  LEDGER_ACCOUNT,
  LEDGER_ENTRY,
} from "constants/actionTypes";

// Array of [ACTION_TYPE, ACTION_FUNCTION] for actions that use the offlineActionCreator and that we want to re-fetch
// the failed object on update/delete failure.
const actionMap = [
  [LEDGER_ACCOUNT, LedgerAccountAction],
  [LEDGER_ENTRY, LedgerEntryAction],
  [BILLING_DOCUMENT, BillingDocumentAction],
  [BILLING_RUN, BillingRunAction],
];

function rollbackFactory(actionFunction) {
  function* rollback(action) {
    const { id } = action;
    if (id) {
      yield put(actionFunction.requestOne({ id }));
    }
  }

  return rollback;
}

export default function* rollbackFailureSaga() {
  yield all(
    flatten(
      actionMap.map(([actionType, actionFunction]) => [
        takeEvery(actionType.UPDATE.FAILURE, rollbackFactory(actionFunction)),
        takeEvery(actionType.DELETE.FAILURE, rollbackFactory(actionFunction)),
      ]),
    ),
  );
}
